import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { CoreModule } from '@dm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SpecifyStrService } from './specify-str.service';
import { SpecifyObjComponent } from './specify-obj.component';



@NgModule({
    declarations: [SpecifyObjComponent],
    exports: [SpecifyObjComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [
        SpecifyStrService,
    ],
})

export class SpecifyObjModule { }

